import {lazy} from 'react'
import * as B from '../block'
import {meta} from './meta'

const Admin = lazy(() => import('./admin').then(m => ({default: m.Admin})))

const GlobalAdmin = lazy(() =>
  import('./admin').then(m => ({default: m.GlobalAdmin})),
)

const InnerBlock = lazy(() =>
  import('./SearchBlock').then(m => ({default: m.SearchBlock})),
)

export const searchBlockInfo = B.blockInfo({
  ...meta,
  Admin,
  GlobalAdmin,
  InnerBlock,
  ssrEnabled: false,
})
